module.exports = __webpack_public_path__ + "static/media/2.5a3136a8.svg";